import { render, staticRenderFns } from "./DDSReportsByProductsCard.vue?vue&type=template&id=31d1c2dc&scoped=true"
import script from "./DDSReportsByProductsCard.vue?vue&type=script&lang=js"
export * from "./DDSReportsByProductsCard.vue?vue&type=script&lang=js"
import style0 from "./DDSReportsByProductsCard.vue?vue&type=style&index=0&id=31d1c2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1c2dc",
  null
  
)

export default component.exports